import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getExamples, markAsExample, removeExample, type CreateExampleInput } from '../api/examples'
import { queryKeys } from '../lib/query-client'

export function useExamples(phenotypeId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.examples.list(phenotypeId || ''),
    queryFn: () => getExamples(phenotypeId!),
    enabled: !!phenotypeId,
    staleTime: 1000 * 60 * 2, // 2 minutes — examples change when user marks/removes
  })
}

export function useMarkAsExample() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateExampleInput) => markAsExample(input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.examples.list(variables.phenotypeId),
      })
    },
  })
}

export function useRemoveExample() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, phenotypeId }: { id: string; phenotypeId: string }) => removeExample(id, phenotypeId),
    onSuccess: (_, { phenotypeId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.examples.list(phenotypeId),
      })
    },
  })
}
